package com.eladfinish.bible.contest.screens.search.usecases.root

import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.extensions.formatWithCommas
import com.eladfinish.bible.contest.network.ApiResult
import com.eladfinish.bible.contest.screens.search.data.SearchRepository
import com.eladfinish.bible.contest.search_summary_format
import dev.icerock.moko.resources.desc.StringDesc
import dev.icerock.moko.resources.desc.desc
import dev.icerock.moko.resources.format
import kotlinx.collections.immutable.toImmutableList

class SearchRootUseCase(
    private val searchRepository: SearchRepository,
    private val rootSearchVerseProvider: RootSearchVerseProvider,
    private val findWordRangesInVerseUseCase: FindWordRangesInVerseUseCase,
) {

    suspend operator fun invoke(
        searchQuery: String,
        onlyQri: Boolean = true,
        onError: (Pair<StringDesc, Throwable>) -> Unit,
    ): Result<SearchRootUiResult> {

        return when (val result = searchRepository.getRootResults(root = searchQuery)) {

            is ApiResult.Success -> {
                val data = result.data

                rootSearchVerseProvider.prefetch(data.verses.map { it.book to it.chapter })

                val uiResults = data.verses.mapIndexedNotNull { index, ref ->
                    val verse = rootSearchVerseProvider(
                        bookIndex = ref.book,
                        chapterIndex = ref.chapter,
                        verseIndex = ref.verse,
                        onlyQri = onlyQri,
                    ) ?: return@mapIndexedNotNull null

                    val ranges = findWordRangesInVerseUseCase(
                        verse = verse.text,
                        wordIndexes = ref.wordIndexes,
                    )

                    verse.copy(
                        id = "${ref.book}_${ref.chapter}_${ref.verse}_$index",
                        highlightedRanges = ranges.toImmutableList(),
                    )
                }

                Result.success(
                    SearchRootUiResult(
                        results = uiResults.toImmutableList(),
                        report = SharedRes.strings.search_summary_format.format(
                            data.total.formatWithCommas(),
                            data.diffVerses.formatWithCommas(),
                        ),
                    ),
                )
            }

            is ApiResult.ClientError -> {
                onError("שגיאה בשרת".desc() to result.throwable)
                Result.failure(result.throwable)
            }

            is ApiResult.Failure -> {
                onError("שגיאת רשת".desc() to result.cause)
                Result.failure(result.cause)
            }
        }
    }
}
